module.exports = __webpack_public_path__ + "img/ic_phone_paused.ca02a809.png";